import React, { useContext, useState } from 'react'
import { toast } from 'react-hot-toast'

import { DataContext } from '../../context/DataContext'
import { useApi } from '../../hooks/useApi'

import Modal from '../shared/Modal'
import Loader from '../shared/Loader'
import NotSentConfirmationModal from './NotSentConfirmation'
import SentConfirmationModal from './SentConfirmation'

interface ReSendModalProps {
  isOpen: boolean
  handleClose: () => void
}

const ReSendModal: React.FC<ReSendModalProps> = ({ isOpen, handleClose }: ReSendModalProps) => {
  const { companyColor } = useContext(DataContext)
  const { resendSaleOrderId } = useApi()

  const [loading, setLoading] = useState(false)
  const [orderSent, setOrderSent] = useState(false)
  const [globalType, setGlobalType] = useState('mail')
  const [globalInput, setGlobalInput] = useState('')
  if (!isOpen) return null

  const handleSubmit = async (type: string, verificationInput: string) => {
    setLoading(true)
    const response = await resendSaleOrderId(verificationInput, type)
    if (response.success) {
      toast.success('Orden reenviada correctamente', {
        duration: 1800
      })
      setOrderSent(true)
    } else {
      toast.error('Error al reenviar la orden', {
        duration: 1800
      })
      setTimeout(() => {
        handleClose()
      }, 2000)
    }
    setLoading(false)
    setGlobalType(type)
    setGlobalInput(verificationInput)
  }

  if (loading) { return (
    <Modal show>
      <div className='flex flex-col justify-center w-full my-8'>
        <Loader />
        <p className='text-center mt-3 font-["Geist"] text-sm'>Validando</p>
      </div>
    </Modal>
  )}

  if (!orderSent) { return (
    <NotSentConfirmationModal
      setOrderSent={setOrderSent}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      companyColor={companyColor}
    />
  )}

  return (
    <SentConfirmationModal
      handleClose={() => {
        handleClose()
        setOrderSent(false)
      }}
      handleSubmit={() => handleSubmit(globalType, globalInput)}
      companyColor={companyColor}
      loading={loading}
    />
  )
}

export default ReSendModal
